// extracted by mini-css-extract-plugin
module.exports = {"page":"internal-module--page--3h5pI"};